import MoreIcon from 'widget/components/MoreLink/primitives/MoreIcon';
import MoreText from 'widget/components/MoreLink/primitives/MoreText';
import StyledExternalLinkWithProps from 'widget/components/MoreLink/primitives/StyledExternalLinkWithProps';

type Props = {
  href: string;
  text: string;
};

export default function MoreLink({ href, text }: Props) {
  return (
    <StyledExternalLinkWithProps data-test="more-link" href={href}>
      <div style={{ float: 'left' }}>
        <MoreIcon />
      </div>
      <MoreText>{text}</MoreText>
    </StyledExternalLinkWithProps>
  );
}
